import { Grid } from 'antd-mobile';
import { GridItem } from 'antd-mobile/es/components/grid/grid';
import { NavListContext } from 'App';
import img from 'app/img';
import FilterBar from 'components/dot/filter-bar';
import TermPostList from 'components/dot/term-post-list';
import TitleNav from 'components/frame/title-nav';
import { url } from 'inspector';
import { useContext, useEffect, useState } from 'react';
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { PagePostDT } from 'services/apis/cnt2/post-api';
import termsApi, { termsDataType, TermsNodeListDT } from 'services/apis/cnt2/term-api';
import { WindowSizeDT } from 'stores/windowSizeSlice';
import { scrollTop } from 'utils/screenUtil';

const Term = () => {
  const termTaxonomy = useLocation().state.termTaxonomy;
  const term: termsDataType = useLocation().state.term;
  const staticPostList: PagePostDT[] = useLocation().state.staticPostList;
  const [sortType, toggleType] = useState('latest'); // latest, trend, hotest

  // console.log('Term', term);
  useEffect(() => {
    scrollTop();
  }, []);
  const windowSize: WindowSizeDT = useSelector((state: any) => state.windowSizeHandle?.windowSize);

  return (
    <div>
      {/* 顶部返回条 */}
      <div className=" sticky top-0 z-20">
        <TitleNav />
      </div>
      {/* 背景卡片 */}
      <div className=" relative">
        {/* 图片 */}
        <div
          style={{
            width: windowSize.width,
            height: windowSize.width * 0.5,
            background: 'url(' + img.bg2 + ') center center / cover no-repeat',
            // background: 'url(' + (term.termBgUrl || img.bg2) + ') center center / cover no-repeat',
            // background-attachment:fixed和background-size:cover不可同时运行
            // 解决：单独元素使用 position: 'fixed'
            position: 'fixed',
            zIndex: 0,
          }}
        >
          {/* 分类 */}
          <div
            className=" text-base text-nowrap text-white bg-gradient-to-br from-black/30 to-black/60 m-2 p-2 shadow-md rounded-xl "
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)' /* 将元素移动回居中 */,
            }}
          >
            {(staticPostList
              ? '专辑'
              : termTaxonomy === 'category'
                ? '分类'
                : termTaxonomy === 'tag'
                  ? '标签'
                  : '主题') +
              ' : ' +
              term.termName?.toUpperCase()}
          </div>
        </div>
      </div>
      {/* 搜索 + 排序 */}
      <div
        className=" sticky top-10 z-10 "
        style={{
          marginTop: windowSize.width * 0.5,
        }}
      >
        <FilterBar
          updateSortType={(sortType: string) => {
            toggleType(sortType);
          }}
        />
      </div>
      {/* 帖子列表 */}
      <TermPostList
        termId={term.termUuid}
        termTaxonomy={termTaxonomy}
        termName={term.termName}
        showTermNamePrefix={null}
        sortType={sortType}
        changeIndexEnabled={false}
        staticPostList={staticPostList}
      />
    </div>
  );
};
export default Term;
